<template>
  <b-modal
    id="recap-add-brouillon-modal"
    ref="modal"
    centered
    class="full-screen-modal"
    no-close-on-backdrop
    no-close-on-esc
    ok-variant="primary">

    <template #modal-header="{ close }">
      <div class="w-100 d-flex row col-12 justify-content-start align-items-center">
        <i class="ph-custom ph-caret-circle-left-bold mr-2 mt-1 cursor-pointer" @click="backToHideAnnonce"/>
        <h1 class="page-title">{{ $t('annonce.my.draft') }}</h1>
      </div>
    </template>

    <div>
      <p>{{ $t('annonce.select.draft') }}</p>
      <div v-if="!isLoading">
        <transition-group class="item-container-draft" name="listCustomTransition" tag="div">
          <div v-for="(annonce, index) in drafts" :key="index+'-draft'" class="item-draft d-flex"
               @click="selectDraft(annonce)">
            <div class="col-4 d-flex align-items-center justify-content-center p-2">
              <div v-if="annonce.vehicleFiles.length > 0" class="container-img-draft">
                <img :src="getFileUrl(annonce.vehicleFiles[0].fileUrl)" alt="Annonce Image" class="rounded">
              </div>
              <div v-else class="container-img-draft">
                <img :src="require('@/assets/images/b122/PLACEHOLDER.png')" alt="no result"
                     class="rounded no-result-img-draft">
              </div>
            </div>
            <div class="col-8 d-flex flex-column justify-content-center">
              <div class="d-flex justify-content-between">
                <div>{{ getAnnonceStr(annonce) }}</div>
              </div>
              <div class="d-flex align-items-center mt-2">
                <i class="ph ph-custom ph-scan main-color cursor-pointer"></i>
                <div class="ml-2">{{ displayValueOrNA(formatAnnonceInfo(annonce)) }}</div>
              </div>
              <div class="d-flex align-items-center mt-2">
                <i class="ph ph-custom ph-map-pin main-color cursor-pointer"></i>
                <div class="ml-2">{{ displayValueOrNA(annonce.address) }}</div>
              </div>
            </div>
          </div>
          <div v-if="drafts.length === 0" key="no-draft-available">
            <div class="no-result">
              <div class="text-center mt-5 mb-2">
                <img :src="require(`@/assets/images/b122/img-perso-ok.png`)" alt="no result" class="no-result-img">
              </div>
              <div class="no-result-text">
                <div class="no-result-title mb-2">{{ $t('annonce.recap.add.draft.emptyTitle') }}</div>
                <div>{{ $t('annonce.recap.add.draft.emptyText') }}</div>
              </div>
            </div>
          </div>
        </transition-group>

      </div>

    </div>


    <template #modal-footer="{ ok, cancel, hide }">
      <div class="w-100 d-flex">
        <b-button class="w-100 mr-2 d-none d-md-block" variant="secondary" @click="handleSubmit()">
          <div class="d-flex justify-content-center">
            <span class="align-self-center mt-small-px">{{ $t('Close') }}</span>
          </div>
        </b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import api from "../../services/api";
import i18n from "../../i18n";

export default {
  name: "RecapAddBrouillonAnnonceModal",

  emits: ['addDraft', 'openRecapAddAnnonceModal'],

  props: {
    annoncesIds: {
      required: true,
      type: Array
    },
  },


  data() {
    return {
      isLoading: true,
      drafts: []
    };
  },

  async mounted() {
    await this.fetchMyDraft()
  },

  watch: {

    'annoncesIds': function (newValue, oldValue) {
      this.fetchMyDraft()
    },

  },

  methods: {
    handleSubmit() {
      this.$bvModal.hide('recap-add-brouillon-modal')
    },

    backToHideAnnonce() {
      this.$emit('openRecapAddAnnonceModal')
    },

    async fetchMyDraft() {
      this.isLoading = true
      api({
        method: "GET",
        url: '/annonce/getMyDraftAnnonceReadyToPublish',
      })
        .then(async (response) => {
          this.drafts = response.data.filter((annonce) => !this.annoncesIds.includes(annonce.id))

          await Promise.all(this.drafts.map(async (annonce) => {
            const modelId = annonce.model
            annonce.model = {
              value: modelId,
              name: modelId ? await this.getModelNameById(modelId) : null,
            }

            const brandId = annonce.brand
            annonce.brand = {
              value: brandId,
              name: brandId ? await this.getBrandNameById(brandId) : null,
            }
          }));
          this.isLoading = false
        })
    },

    formatAnnonceInfo(annonce) {
      let parts = [];
      if (annonce.licensePlate) parts.push(annonce.licensePlate);
      if (annonce.vin) parts.push(annonce.vin);
      if (annonce.bicycode) parts.push(annonce.bicycode);

      return parts.join(' | ');
    },

    getAnnonceStr(annonce) {
      if (annonce.brand.name && annonce.model.name) {
        return annonce.brand.name + " - " + annonce.model.name
      } else if (annonce.brand.name) {
        return annonce.brand.name
      } else {
        return "Aucune information enregistrée"
      }
    },

    displayValueOrNA(value) {
      if (value === null || value === undefined || (typeof value === 'string' && value.trim() === "")) {
        return 'Non renseigné';
      } else {
        return value;
      }
    },

    async getModelNameById(modelId) {
      try {
        const response = await api.get(`/model/getNameById/${modelId}`);
        return response.data.name;
      } catch (error) {
        console.error("Error fetching model name", error);
        this.isLoading = false
        return "Unknown Model";
      }
    },

    async getBrandNameById(brandId) {
      try {
        const response = await api.get(`/brand/getNameById/${brandId}`);
        return response.data.name;
      } catch (error) {
        console.error("Error fetching brand name", error);
        this.isLoading = false
        return "Unknown Brand";
      }
    },

    selectDraft(annonce) {
      console.log(annonce)
      this.$emit('addDraft', annonce)
    },

    getFileUrl(path) {
      return (window.location.hostname === "integration-grand-public-lamp.bleu122.com" ? "https://integration-lamp.bleu122.com" : process.env.SERVER_URL) + path
    },

  },
};
</script>

<!-- not scoped car modal -->
<style>

#recap-add-brouillon-modal .item-container-draft {
  display: flex;
  flex-wrap: wrap;
  -ms-flex: 0 0 100%;
  -webkit-box-flex: 0;
  flex: 0 0 100%;
  max-width: 100%;
  gap: 1em;
}

#recap-add-brouillon-modal .container-img-draft {
  width: 150px;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}

#recap-add-brouillon-modal .container-img-draft img {
  max-width: 150px;
  max-height: 150px;
  object-fit: cover;
}

#recap-add-brouillon-modal .no-result-img-draft {
  object-fit: contain;
}

#recap-add-brouillon-modal .item-draft {
  -ms-flex: 0 0 100%;
  -webkit-box-flex: 0;
  flex: 0 0 100%;
  max-width: 100%;
  flex-direction: row;
  border-radius: 10px;
  background-color: var(--main-black-medium);
  border: 1px solid var(--main-black-medium);
}

#recap-add-brouillon-modal .no-result {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  color: var(--main-grey-medium);
}

#recap-add-brouillon-modal .no-result-text {
  text-align: center;
  max-width: 400px;
}

#recap-add-brouillon-modal .no-result-img {
  max-width: 50%;
}

#recap-add-brouillon-modal .no-result-title {
  color: var(--main-grey-light);
  font-family: "KumbhSans-Bold", "Arial", sans-serif;
}


#recap-add-brouillon-modal .item-draft:hover,
#recap-add-brouillon-modal .item-active-draft {
  cursor: pointer;
  border-color: var(--main-yellow-medium) !important;
}

#recap-add-brouillon-modal .modal-content,
#recap-add-brouillon-modal .modal-header,
#recap-add-brouillon-modal .modal-body,
#recap-add-brouillon-modal .modal-footer {
  background-color: var(--main-black-dark) !important;
}

#recap-add-brouillon-modal .modal-content {
  display: flex;
  flex-direction: column;
}

#recap-add-brouillon-modal .modal-header, .modal-footer {
  flex-shrink: 0;
}

#recap-add-brouillon-modal .modal-body {
  overflow-y: auto;
  flex-grow: 1;
}

#recap-add-brouillon-modal .draft-header-content {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 0;
  border-bottom: none;
}

#recap-add-brouillon-modal .title-container-recap-draft {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  text-align: left;
  flex-direction: column;
}

@media (min-width: 992px) {
  #recap-add-brouillon-modal .title-container-recap-draft {
    flex-direction: column;
  }
}

@media (max-width: 991px) {
  #recap-add-brouillon-modal .title-container-recap-draft img {
    order: 2;
    align-self: center;
  }

  #recap-add-brouillon-modal .title-container-recap-draft {
    text-align: center;
  }
}

#recap-add-brouillon-modal .modal-content {
  overflow: hidden;
  border-radius: 30px;
}


.full-screen-modal .modal-dialog {
  max-width: 100%;
  margin: 0;
}

.full-screen-modal .modal-content {
  height: auto;
  border-radius: 30px;
}

@media (max-width: 767px) {
  #recap-add-brouillon-modal .modal-content {
    display: flex;
    overflow: auto;
  }

  #recap-add-brouillon-modal .modal-dialog {
    max-width: 100%;
    margin: 0;
  }

  #recap-add-brouillon-modal .modal-body {
    display: flex;
    justify-content: center;
    align-items: flex-start;
  }

  #recap-add-brouillon-modal .modal-dialog {
    max-width: 100%;
    margin: 0;
  }

  #recap-add-brouillon-modal .modal-content {
    padding: 0;
    border-radius: 0;
  }

  #recap-add-brouillon-modal .draft-header-content, #recap-add-brouillon-modal .title-container-recap-draft {
    padding: 10px;
  }
}


#recap-add-brouillon-modal .btn-secondary {
  background-color: var(--main-black-dark) !important;
  border-color: var(--main-grey-light) !important;
  color: var(--main-white);
  border-radius: var(--main-border-radius);
  padding: 12px 20px;
  font-size: var(--content-font-size);
}

#recap-add-brouillon-modal .btn-secondary:hover:not([disabled]) {
  background-color: var(--main-black-medium) !important;
}

#recap-add-brouillon-modal .custom-switch {
  margin-bottom: 1rem;
}

#recap-add-brouillon-modal .permission-toggle {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>



// WEBPACK FOOTER //
// src/components/annonce/RecapAddBrouillonAnnonceModal.vue